"use client";
import { InfoCircleOutlined, SearchOutlined } from "@ant-design/icons";
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
  Tooltip,
} from "antd";
import PreviewTable from "../../../components/PreviewTable";
import { staticConfig } from "../../customer/customer.config";

const CollateralOverview = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    dataSections,
    searchData,
    onSearch,
    searchParam,
    isEdit,
  } = props;

  const isSearchDisabled =
    !searchParam || searchParam?.length < 5 ? true : false;

  const isFieldDisabled = isEdit ? false : isSearchDisabled;
  console.log(searchData);
  console.log(isSearchDisabled);

  return (
    <div>
      <h1
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          margin: 0,
          marginBottom: "24px",
        }}
      >
        Collateral Overview
      </h1>

      <Form
        className="custom-form"
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={initialValues}
        style={{ width: "100%" }}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  CIF Number
                  <Tooltip title="Enter the Customer Identification File number">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="cifNumber"
              // style={{ marginBottom: 0 }}
              // rules={[
              //   {
              //     required: true,
              //     message: "CIF Number is required",
              //   },
              // ]}
            >
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  className="bond-input"
                  style={{ height: 44 }}
                  placeholder="Enter CIF Number"
                  onPressEnter={onSearch}
                  allowClear
                />
                <Button
                  onClick={onSearch}
                  className="of-primaryBtnColor"
                  style={{ height: 44 }}
                >
                  <SearchOutlined />
                </Button>
              </Space.Compact>
            </Form.Item>
          </Col>
        </Row>

        {searchData && (
          <Col span={24} style={{ marginBottom: 30 }}>
            <PreviewTable data={dataSections} />
          </Col>
        )}

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Collateral Name
                  <Tooltip title="Enter collateral name">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="collateralName"
              rules={[
                {
                  required: true,
                  message: "Collateral name is required",
                },
              ]}
            >
              <Input
                className="bond-input"
                style={{ height: 44 }}
                placeholder="Enter collateral name"
                disabled={isFieldDisabled}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Issuer Code (Securities)
                  <Tooltip title="Enter issuer code for securities (optional)">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="issuerCode"
            >
              <Input
                className="bond-input"
                style={{ height: 44 }}
                placeholder="Enter issuer code (optional)"
                disabled={isFieldDisabled}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Ownership Verified
                  <Tooltip title="Select whether ownership is verified">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="ownershipVerified"
              rules={[
                {
                  required: true,
                  message: "Please select ownership verified status",
                },
              ]}
            >
              <Select
                placeholder="Select ownership verified status"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={staticConfig.yesOrNoData}
                disabled={isFieldDisabled}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Registration Date
                  <Tooltip title="Select the registration date">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="registrationDate"
              rules={[
                {
                  required: true,
                  message: "Registration date is required",
                },
              ]}
            >
              <DatePicker
                className="bond-date-picker"
                style={{
                  width: "100%",
                  height: 44,
                  display: "flex",
                  alignItems: "center",
                  padding: "0 11px",
                  fontSize: 14,
                }}
                suffixIcon={<CalendarIcon color="#667085" width={20} />}
                disabled={isFieldDisabled}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Collateral Code
                  <Tooltip title="System-generated collateral code">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="collateralCode"
            >
              <Input
                className="bond-input of-bold-disable-input"
                style={{ height: 44 }}
                placeholder="System-generated"
                disabled
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Collateral Description
                  <Tooltip title="Enter a description for the collateral">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="description"
              rules={[
                {
                  required: true,
                  message: "Collateral description is required",
                },
              ]}
            >
              <Input.TextArea
                className="bond-input"
                style={{ height: 88, resize: "none" }}
                placeholder="Enter collateral description"
                disabled={isFieldDisabled}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CollateralOverview;
